import type { RouteLocationNormalizedGeneric } from '#vue-router'

import { useMiddlewareChangelogQuery } from '@composables/middleware/changelog-query.hook'

import { defineNuxtRouteMiddleware } from '#app'

/** `/bookings/{id}/changelog` — the changelog table reads this lesson's own actions. */
export default defineNuxtRouteMiddleware((to: RouteLocationNormalizedGeneric) => {
  const bookingId = to.params.id

  if (typeof bookingId !== 'string' || !bookingId) return

  useMiddlewareChangelogQuery(to, {
    route: 'admin.booking.changelog',
    params: { booking_id: bookingId },
  })
})
